module.exports = __webpack_public_path__ + "static/media/admin-handle.0692e308.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin-handle.svg
// module id = 866
// module chunks = 0